import service from '../../utils/Service'

export default function getGooglePlacesAction(searchStr) {
   if (searchStr === "") {
      return {
         type: 'GET_GOOGLE_PLACES_FULFILLED',
         payload: {data: []}
      };
   }
   return {
      type: 'GET_GOOGLE_PLACES',
      payload: service.getGooglePlacesAutocomplete(searchStr)
   };
}


// WEBPACK FOOTER //
// ./src/actions/events/getGooglePlacesAction.js